import Vue from 'vue';

export const getConfig = (configName) => {
    return Vue.prototype.$env[configName] || process.env[configName];
}

export const getApiUrl = () => {
    return getConfig("VUE_APP_API_URL");
}
